/** Grid Profile Report API 샘플 데이터. 타입은 @see GridProfileData */
export const gridProfileMockData = {
    customer: {
        name: 'INTC3 AY',
        email: 'youngguk.bae@qcells.com',
        address: '2971 Warren Ln, El Dorado Hills CA 95762, United States',
    },
    configurationType: 'backup',
    acCombinerInfo: {
        serialNumber: '342611100003M60333',
        gemVersion: 17245640,
        emsVersion: 'X100126-AC',
        microInverterCount: 1,
        gridProfile: 'Rule 21 (California)',
    },
    batteryInfo: [
        {
            serialNumber: '342711176014N16111',
            emsVersion: 'R090216-AC',
            pcsVersion: '050003',
            bmsVersion: '01010001',
            gridProfile: 'Rule 21 (California)',
        },
        {
            serialNumber: '342711176014N16222',
            emsVersion: 'X100126-AC',
            pcsVersion: '050000',
            bmsVersion: '01010001',
            gridProfile: 'Rule 21 (California)',
        },
    ],
    microinverterInfo: {
        totalMicroinverters: 1,
        microinverters: [
            {
                serialNumber: '2M125EV00536',
                modelNumber: 'Q.MI-349B-G1',
                installedDate: '2026-03-06T01:21:06Z',
                gridProfile: 'Rule 21 (California)',
            },
        ],
    },
    configuration: [
        {
            deviceTypeCd: 'AC_COMB',
            countryCode: 840,
            gridCode: 8453,
            installDone: 0,
            energyPolicy: 0,
            pvConnectionType: 2,
            dynamicOptimizer: 0,
            pcsConnectionMode: 0,
            pcsDebugMode: 0,
            autoFwUpdateFlag: 1,
            emsPriorityId: 0,
            siteInfo: {
                backupConfigType: 0,
                gridSupportSubPanel: 0,
                thirdPartyEss: 0,
                mixedTariff: 0,
                thirdPartyPvMonitoringFlag: null,
                rogowskiCoilFlag: null,
            },
            stormCover: {
                flag: 0,
                chargeType: 0,
            },
            installerPageTempPassword: {
                settingTime: 0,
            },
            webPagePassword: {
                engineer: '09F945AFFA323C5A637E12B9E6F0AFA3',
                service: 'C3363608D8FAE5610D2215620F5F5712',
            },
            eos: {
                flag: 0,
                powerSamplingInterval: 60000,
                defaultSamplingInterval: 60000,
            },
            fcas: {
                flag: 0,
                responseCapacityLimit: 0,
                droopRateRaise: 0.7,
                droopRateLower: 0.7,
                oftbMax: 51,
                oftbMin: 49,
                frMax: 50.5,
                frMin: 49.5,
                nofbMax: 50.15,
                nofbMin: 49.85,
                testMode: 0,
            },
            esm: {
                flag: 0,
                limitLevel: 0,
            },
            dcOptimizer: {
                userRsd: 0,
                mstTxGain: 0,
                slvTxGain: 0,
            },
            ul3141: {
                essMode: 0,
            },
            ul1741: {
                flag: 0,
            },
            afci: {
                arcEnergyRegion: 0,
                ch1: {
                    flag: 0,
                    timeAreaThresholdGain: 0,
                    frequencyAreaThresholdGain: 0,
                    frequencyAreaThresholdPercent: 0,
                },
                ch2: {
                    flag: 0,
                    timeAreaThresholdGain: 0,
                    frequencyAreaThresholdGain: 0,
                    frequencyAreaThresholdPercent: 0,
                },
                ch3: {
                    flag: 0,
                    timeAreaThresholdGain: 0,
                    frequencyAreaThresholdGain: 0,
                    frequencyAreaThresholdPercent: 0,
                },
            },
            battery: {
                backupSoc: 0,
                installedRackCount: 0,
                chargeLimit: 0,
                dischargeLimit: 0,
                hysteresisLow: 0,
                hysteresisHigh: 0,
                userSocMin: 5,
                userSocMax: 100,
            },
            inverter: {
                maxOutputPower: 0,
                gridTargetFrequency: 60,
                externalGeneratorMode: 0,
                permitServiceModeSelect: 1,
                enterServiceRandomizedDelay: 0,
                multipleEarthedNeutralSystem: 0,
                randomizedDelayTime: 300,
                importPowerLimit: 0,
                exportPowerLimit: 0,
                reconnectionTime: 15,
                tauCoefficient: 0,
                logicInterface: 0,
            },
            pv: {
                type: 1,
                capacityCalcOption: 0,
                feedInLimit: 0,
                feedInLimitW: 0,
                feedInLimitFlag: 0,
                inverterNameplatePower: 15356,
                module: {
                    count: 0,
                    power: 0,
                },
                microInverter: {
                    count: 1,
                },
                string: {
                    count: 0,
                    power1: 0,
                    power2: 0,
                    power3: 0,
                    power4: 0,
                    power5: 0,
                },
            },
            meter: {
                model: 0,
                connection: 2,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc3',
                    rtuBaudrate: 9600,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            pvMeter: {
                model: 0,
                connection: 0,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc0',
                    rtuBaudrate: 9600,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            externalControl: {
                meterLoad: 0,
                pvMeterLoad: 0,
                connection: 0,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc0',
                    rtuBaudrate: 115200,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            tou: {
                weekday: {
                    count: 0,
                },
                weekend: {
                    count: 0,
                },
            },
            sgReady: {
                flag: 0,
                heatPumpConsumptionPower: 0,
            },
            secondaryEms: {
                serverId: 1,
                modbus: {
                    tcpPort: 0,
                },
            },
            externalEms: {
                model: 0,
                connection: 1,
                serverId: 0,
                gridCode: 0,
                meter1: 0,
                meter2: 0,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc0',
                    rtuBaudrate: 9600,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            hub: {
                inverterCount: 0,
                externalCtInstalledPoint: 0,
                essInverter: null,
                generator: {
                    flag: 0,
                    remoteOn: 1,
                    nameplatePower: 0,
                    lowSoc: 50,
                    userAuto: 1,
                    userManual: 0,
                    maintenanceMode: 0,
                    maintenanceModeDuration: 15,
                    genToEssModeStartSoc: 15,
                    genToEssModeStopSoc: 85,
                    maintenanceFrequencyType: 1,
                    maintenanceDayOfWeek: 2,
                    maintenanceDayOfMonth: 1,
                    maintenanceHour: 14,
                    maintenanceMinute: 0,
                },
            },
            microInverter: {
                esRmpTms: 0.33,
                wattSetMod: 0,
                totalMaxOutputPower: 19200,
                ena: {
                    flagNrConfig: 0,
                    tov: 0,
                    gfdi: 1,
                    rmp: 0,
                    flagDynCurrEventBase: 0,
                },
                nameplateRatings: {
                    vmax: 120,
                    vmin: 0,
                    amax: 100,
                },
                pvSettings: {
                    vpvMin: 16,
                    vpvMax: 60,
                    ipvMax: 15,
                    tempMax: 95,
                    tempMin: -45,
                    powCalib: 17,
                },
                derTrip: {
                    lvCrvMomCessPt: 120,
                    hvCrvMomCessPt: 288,
                },
                derFreqDroop: {
                    freqWattPmax: 100,
                    ctlPmin: 5,
                },
                wRmp: 100,
                wRmpRef: 0,
            },
            accb: {
                flag: 0,
                consumptionCtInstalledPoint: 0,
                extendedProductionCtFlag: 0,
                polarity: {
                    reverseProductionCt: 0,
                    reverseConsumptionL1Ct: 0,
                    reverseConsumptionL2Ct: 0,
                    reverseExtProductionCt: 0,
                },
            },
            msp: {
                mspBusbarRating: 200,
                mspBreakerRating: 200,
                busbarProtectionFlag: 0,
                derBreakerRating: 40,
                pvBreakerRating: 40,
                essBreakerRating: 40,
            },
            logLevel: {
                processMgr: 1,
                systemLog: 1,
                fota: 1,
                powerControl: 1,
                algorithmMgr: 1,
                essMgr: 1,
                dcSourceMgr: 1,
                cloudMgr: 1,
                meterMgr: 1,
                gatewayMgr: 1,
                dataAccumulator: 1,
                dbMgr: 1,
                webEngine: 1,
                gqa: 1,
                mlpeMgr: 1,
                sysMgr: 1,
                powerScheduler: null,
                echonetMgr: 1,
                energyLink: 1,
                diagMonitor: 1,
                csipMgr: 1,
                energyOptimizer: 1,
                ipcBridge: 1,
                energyMonitor: 1,
                energyScheduler: 1,
            },
            debugMode: {
                modbus: 0,
                mqtt: 1,
            },
            siteConfiguration: {
                disableMode: 0,
            },
            gridVoltage: {
                overVoltage: {
                    detectionLevel1: 264,
                    detectionTime1: 13000,
                    detectionLevel2: 288,
                    detectionTime2: 160,
                    detectionLevel3: 0,
                    detectionTime3: 0,
                    detectionLevel4: 0,
                    detectionTime4: 0,
                    detectionLevel5: 0,
                    detectionTime5: 0,
                    releaseLevel: 254,
                    releaseTime: 0,
                },
                underVoltage: {
                    detectionLevel1: 211.2,
                    detectionTime1: 21000,
                    detectionLevel2: 168,
                    detectionTime2: 11000,
                    detectionLevel3: 120,
                    detectionTime3: 2000,
                    detectionLevel4: 0,
                    detectionTime4: 0,
                    detectionLevel5: 0,
                    detectionTime5: 0,
                    releaseLevel: 212,
                    releaseTime: 0,
                },
                tenMinVoltage: {
                    detectionLevel: 0,
                },
            },
            gridFrequency: {
                overFrequency: {
                    detectionLevel1: 61.2,
                    detectionTime1: 300000,
                    detectionLevel2: 62,
                    detectionTime2: 160,
                    detectionLevel3: 0,
                    detectionTime3: 0,
                    detectionLevel4: 0,
                    detectionTime4: 0,
                    detectionLevel5: 0,
                    detectionTime5: 0,
                    releaseLevel: 60.5,
                    releaseTime: 0,
                },
                underFrequency: {
                    detectionLevel1: 58.5,
                    detectionTime1: 300000,
                    detectionLevel2: 56.5,
                    detectionTime2: 160,
                    detectionLevel3: 0,
                    detectionTime3: 0,
                    detectionLevel4: 0,
                    detectionTime4: 0,
                    detectionLevel5: 0,
                    detectionTime5: 0,
                    releaseLevel: 59,
                    releaseTime: 0,
                },
            },
            activePower: {
                flag: 1,
                setPointValue: 100,
                frequency: {
                    flag: 1,
                    hysteresisSelect: 0,
                    slopeSelect: 0,
                    ofPrefSelect: 0,
                    ufPrefSelect: 0,
                    x1: 0,
                    x2: 0,
                    x3: 59.964,
                    x4: 60.036,
                    x5: 0,
                    x6: 0,
                    sl: 0,
                    sh: 0,
                    droopKof: 0.05,
                    droopKuf: 0.05,
                    ofHysteresisFrequency: 0,
                    ofHysteresisTime: 0,
                    ufHysteresisFrequency: 0,
                    ufHysteresisTime: 0,
                    responseTime: 5000,
                },
                voltage: {
                    flag: 1,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                    x3: 254.4,
                    y3: 100,
                    x4: 264,
                    y4: 0,
                    responseTime: 5000,
                },
            },
            reactivePower: {
                autoVrefAvgTime: 300,
                cospiSetPoint: {
                    flag: 0,
                    excitedSelect: 1,
                    apparentPowerPriority: 1,
                    value: 1,
                    responseTime: 10000,
                },
                cospiP: {
                    flag: 0,
                    excitedSelect: 0,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                    x3: 0,
                    y3: 0,
                    responseTime: 0,
                },
                qSetPoint: {
                    flag: 0,
                    excitedSelect: 0,
                    apparentPowerPriority: 1,
                    reactivePowerMode: 3,
                    value: 44,
                    responseTime: 5000,
                },
                qU: {
                    flag: 1,
                    fixedVrefSelect: 0,
                    apparentPowerPriority: 1,
                    reactivePowerMode: 3,
                    vref: 240,
                    x1: 220.8,
                    y1: 30,
                    x2: 232.8,
                    y2: 0,
                    x3: 247.2,
                    y3: 0,
                    x4: 256.8,
                    y4: -30,
                    responseTime: 5000,
                },
                qP: {
                    flag: 0,
                    apparentPowerPriority: 1,
                    reactivePowerMode: 3,
                    responseTime: 10000,
                    gen: {
                        x1: 20,
                        y1: 0,
                        x2: 50,
                        y2: 0,
                        x3: 100,
                        y3: -44,
                    },
                    load: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 0,
                        x3: 0,
                        y3: 0,
                    },
                },
            },
            dcInjection: {
                flag: 0,
                controlFlag: 0,
                controlLevel: 0,
                detectionLevel1: 0,
                detectionTime1: 0,
                detectionLevel2: 0,
                detectionTime2: 0,
            },
            rcmu: {
                sudden: {
                    flag: 0,
                    detectionLevel1: 0,
                    detectionTime1: 0,
                    detectionLevel2: 0,
                    detectionTime2: 0,
                    detectionLevel3: 0,
                    detectionTime3: 0,
                },
                continuous: {
                    flag: 0,
                    detectionLevel: 0,
                    detectionTime: 0,
                },
            },
            pvInsulation: {
                flag: 0,
                faultLevel: 0,
                checkCnt: 0,
                time: 0,
            },
            antiIslanding: {
                activeMethodDetection: 1,
                passiveMethodDetection: 0,
                freqFeedbackFunction: 0,
                stepInjectionFunction: 0,
                reactivePowerSuppression: 0,
                gain1: 0,
                gain2: 0,
                freqFeedbackQmax: 0,
                stepInjectionQmax: 0,
            },
            gradient: {
                flag: 0,
                energySourceChange: 0,
                unitReferenceSelect: 0,
                activePowerGradient: 2,
                activePowerSetPointGradient: 0,
            },
            derating: {
                flag: 0,
                startTemp: 0,
                value: 0,
            },
            feedinRelay: {
                flag: 0,
                attachLevel: {
                    relay1: 0,
                    relay2: 0,
                    relay3: 0,
                    relay4: 0,
                },
                detachLevel: {
                    relay1: 0,
                    relay2: 0,
                    relay3: 0,
                    relay4: 0,
                },
            },
            inverterControl: {
                gridTargetVoltage: 240,
                gridTargetVoltageOffset: 0,
                pcsMaxApparentPowerLimit: 15356,
                chargeRateSetting: 0,
                dischargeRateSetting: 0,
                vaSetting: 0,
                exportPmin: 0,
                importPmin: 0,
                pcsVarMax: {
                    q1: 8089,
                    q2: 0,
                    q3: 0,
                    q4: 0,
                },
                pfMin: {
                    q1: 0.85,
                    q2: -0.85,
                    q3: 0,
                    q4: 0,
                },
                activePower: {
                    setting: 15356,
                    overExcitedSetting: 13052,
                    underExcitedSetting: 13052,
                },
                vArAct: 0,
            },
            dynamicReactiveCurrent: {
                flag: 0,
                arGraMod: 0,
                arGraSag: 0,
                arGraSwell: 0,
                dbVMin: 0,
                dbVMax: 0,
                holdTmms: 0,
                filterTms: 0,
            },
            frt: {
                hvrt: 1,
                lvrt: 1,
                hfrt: 1,
                lfrt: 1,
                startLevel: {
                    hvrt: 0,
                    lvrt: 0,
                    hfrt: 0,
                    lfrt: 0,
                },
            },
            voltageRiseSuppression: {
                flag: 0,
                vref: 0,
                delayTime: 0,
                minPf: 0,
                pfResponseTime: 0,
                minActivePower: 0,
                activePowerResponseTime: 0,
                releaseTime: 0,
            },
            limitControl: {
                exportHardLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                exportSoftLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                generationHardLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                generationSoftLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                ess: {
                    exportLimit: 30400,
                    importLimit: -30400,
                },
            },
            cls: {
                exportLimit: 5000,
                importLimit: 18400,
            },
        },
        {
            deviceTypeCd: 'AC_ESS',
            countryCode: 840,
            gridCode: 8403,
            installDone: 1,
            energyPolicy: 1,
            pvConnectionType: 2,
            dynamicOptimizer: 0,
            pcsConnectionMode: 0,
            pcsDebugMode: 0,
            autoFwUpdateFlag: 1,
            emsPriorityId: 1,
            siteInfo: {
                backupConfigType: 2,
                gridSupportSubPanel: 0,
                thirdPartyEss: 0,
                mixedTariff: null,
                thirdPartyPvMonitoringFlag: null,
                rogowskiCoilFlag: null,
            },
            stormCover: {
                flag: 0,
                chargeType: 0,
            },
            installerPageTempPassword: {
                settingTime: 0,
            },
            webPagePassword: {
                engineer: '2FF6F6C9A35E8EC489694253E02953B6',
                service: 'AA9CDD78A6B2CCA533562C1647CB96AF',
            },
            eos: {
                flag: 0,
                powerSamplingInterval: 60000,
                defaultSamplingInterval: 60000,
            },
            fcas: {
                flag: 0,
                responseCapacityLimit: 0,
                droopRateRaise: 0.7,
                droopRateLower: 0.7,
                oftbMax: 51,
                oftbMin: 49,
                frMax: 50.5,
                frMin: 49.5,
                nofbMax: 50.15,
                nofbMin: 49.85,
                testMode: 0,
            },
            esm: {
                flag: 0,
                limitLevel: 0,
            },
            dcOptimizer: {
                userRsd: 0,
                mstTxGain: 0,
                slvTxGain: 0,
            },
            ul3141: {
                essMode: 0,
            },
            ul1741: {
                flag: 0,
            },
            afci: {
                arcEnergyRegion: 0,
                ch1: {
                    flag: 0,
                    timeAreaThresholdGain: 0,
                    frequencyAreaThresholdGain: 0,
                    frequencyAreaThresholdPercent: 0,
                },
                ch2: {
                    flag: 0,
                    timeAreaThresholdGain: 0,
                    frequencyAreaThresholdGain: 0,
                    frequencyAreaThresholdPercent: 0,
                },
                ch3: {
                    flag: 0,
                    timeAreaThresholdGain: 0,
                    frequencyAreaThresholdGain: 0,
                    frequencyAreaThresholdPercent: 0,
                },
            },
            battery: {
                backupSoc: 0,
                installedRackCount: 1,
                chargeLimit: -7833,
                dischargeLimit: 7833,
                hysteresisLow: 15,
                hysteresisHigh: 90,
                userSocMin: 5,
                userSocMax: 100,
            },
            inverter: {
                maxOutputPower: 7600,
                gridTargetFrequency: 60,
                externalGeneratorMode: 0,
                permitServiceModeSelect: 1,
                enterServiceRandomizedDelay: 0,
                multipleEarthedNeutralSystem: 0,
                randomizedDelayTime: 300,
                importPowerLimit: -7600,
                exportPowerLimit: 7600,
                reconnectionTime: 15,
                tauCoefficient: 2.3,
                logicInterface: 0,
            },
            pv: {
                type: 0,
                capacityCalcOption: 0,
                feedInLimit: -1,
                feedInLimitW: 38400,
                feedInLimitFlag: 0,
                inverterNameplatePower: 15356,
                module: {
                    count: 0,
                    power: 0,
                },
                microInverter: {
                    count: 0,
                },
                string: {
                    count: 0,
                    power1: 0,
                    power2: 0,
                    power3: 0,
                    power4: 0,
                    power5: 0,
                },
            },
            meter: {
                model: 0,
                connection: 2,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc3',
                    rtuBaudrate: 9600,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            pvMeter: {
                model: 0,
                connection: 0,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc0',
                    rtuBaudrate: 9600,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            externalControl: {
                meterLoad: 0,
                pvMeterLoad: 0,
                connection: 0,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc0',
                    rtuBaudrate: 115200,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            tou: {
                weekday: {
                    count: 0,
                },
                weekend: {
                    count: 0,
                },
            },
            sgReady: {
                flag: 0,
                heatPumpConsumptionPower: 0,
            },
            secondaryEms: {
                serverId: 1,
                modbus: {
                    tcpPort: 0,
                },
            },
            externalEms: {
                model: 0,
                connection: 1,
                serverId: 0,
                gridCode: 0,
                meter1: 0,
                meter2: 0,
                modbus: {
                    tcpPort: 0,
                    rtuDev: '/dev/ttymxc0',
                    rtuBaudrate: 9600,
                    rtuParity: 'N',
                    rtuData: 8,
                    rtuStop: 1,
                },
            },
            hub: {
                inverterCount: 2,
                externalCtInstalledPoint: 1,
                essInverter: [
                    {
                        flag: 0,
                        nameplatePower: 7600,
                    },
                    {
                        flag: 0,
                        nameplatePower: 7600,
                    },
                ],
                generator: {
                    flag: 0,
                    remoteOn: 0,
                    nameplatePower: 0,
                    lowSoc: 50,
                    userAuto: null,
                    userManual: null,
                    maintenanceMode: null,
                    maintenanceModeDuration: null,
                    genToEssModeStartSoc: null,
                    genToEssModeStopSoc: null,
                    maintenanceFrequencyType: null,
                    maintenanceDayOfWeek: null,
                    maintenanceDayOfMonth: null,
                    maintenanceHour: null,
                    maintenanceMinute: null,
                },
            },
            microInverter: {
                esRmpTms: 0.33,
                wattSetMod: 0,
                totalMaxOutputPower: 19200,
                ena: {
                    flagNrConfig: 0,
                    tov: 0,
                    gfdi: 0,
                    rmp: 0,
                    flagDynCurrEventBase: 0,
                },
                nameplateRatings: {
                    vmax: 120,
                    vmin: 0,
                    amax: 100,
                },
                pvSettings: {
                    vpvMin: 16,
                    vpvMax: 60,
                    ipvMax: 15,
                    tempMax: 0,
                    tempMin: -45,
                    powCalib: 0,
                },
                derTrip: {
                    lvCrvMomCessPt: 0,
                    hvCrvMomCessPt: 0,
                },
                derFreqDroop: {
                    freqWattPmax: 100,
                    ctlPmin: 20,
                },
                wRmp: 100,
                wRmpRef: 0,
            },
            accb: {
                flag: 0,
                consumptionCtInstalledPoint: 0,
                extendedProductionCtFlag: 0,
                polarity: {
                    reverseProductionCt: 0,
                    reverseConsumptionL1Ct: 0,
                    reverseConsumptionL2Ct: 0,
                    reverseExtProductionCt: 0,
                },
            },
            msp: {
                mspBusbarRating: 200,
                mspBreakerRating: 200,
                busbarProtectionFlag: 0,
                derBreakerRating: 40,
                pvBreakerRating: 40,
                essBreakerRating: 40,
            },
            logLevel: {
                processMgr: 4,
                systemLog: 4,
                fota: 4,
                powerControl: 4,
                algorithmMgr: 1,
                essMgr: 4,
                dcSourceMgr: 1,
                cloudMgr: 0,
                meterMgr: 4,
                gatewayMgr: 4,
                dataAccumulator: 4,
                dbMgr: 4,
                webEngine: 4,
                gqa: 1,
                mlpeMgr: 4,
                sysMgr: 4,
                powerScheduler: null,
                echonetMgr: 1,
                energyLink: 4,
                diagMonitor: 4,
                csipMgr: 4,
                energyOptimizer: 4,
                ipcBridge: 4,
                energyMonitor: 4,
                energyScheduler: 4,
            },
            debugMode: {
                modbus: 0,
                mqtt: 0,
            },
            siteConfiguration: {
                disableMode: 0,
            },
            gridVoltage: {
                overVoltage: {
                    detectionLevel1: 288,
                    detectionTime1: 160,
                    detectionLevel2: 288,
                    detectionTime2: 160,
                    detectionLevel3: 288,
                    detectionTime3: 13000,
                    detectionLevel4: 264,
                    detectionTime4: 13000,
                    detectionLevel5: 264,
                    detectionTime5: 13000,
                    releaseLevel: 254,
                    releaseTime: 200,
                },
                underVoltage: {
                    detectionLevel1: 0,
                    detectionTime1: 2000,
                    detectionLevel2: 120,
                    detectionTime2: 2000,
                    detectionLevel3: 120,
                    detectionTime3: 21000,
                    detectionLevel4: 211.2,
                    detectionTime4: 21000,
                    detectionLevel5: 211.2,
                    detectionTime5: 50000,
                    releaseLevel: 212,
                    releaseTime: 200,
                },
                tenMinVoltage: {
                    detectionLevel: 264,
                },
            },
            gridFrequency: {
                overFrequency: {
                    detectionLevel1: 66,
                    detectionTime1: 160,
                    detectionLevel2: 62,
                    detectionTime2: 160,
                    detectionLevel3: 62,
                    detectionTime3: 300000,
                    detectionLevel4: 61.2,
                    detectionTime4: 300000,
                    detectionLevel5: 61.2,
                    detectionTime5: 1000000,
                    releaseLevel: 60.5,
                    releaseTime: 200,
                },
                underFrequency: {
                    detectionLevel1: 50,
                    detectionTime1: 160,
                    detectionLevel2: 56.5,
                    detectionTime2: 160,
                    detectionLevel3: 56.5,
                    detectionTime3: 300000,
                    detectionLevel4: 58.5,
                    detectionTime4: 300000,
                    detectionLevel5: 58.5,
                    detectionTime5: 1000000,
                    releaseLevel: 59,
                    releaseTime: 200,
                },
            },
            activePower: {
                flag: 0,
                setPointValue: 100,
                frequency: {
                    flag: 1,
                    hysteresisSelect: 0,
                    slopeSelect: 0,
                    ofPrefSelect: 0,
                    ufPrefSelect: 0,
                    x1: 59.964,
                    x2: 59.964,
                    x3: 59.964,
                    x4: 60.036,
                    x5: 60.036,
                    x6: 60.036,
                    sl: 0,
                    sh: 0,
                    droopKof: 0.05,
                    droopKuf: 0.05,
                    ofHysteresisFrequency: 0,
                    ofHysteresisTime: 0,
                    ufHysteresisFrequency: 0,
                    ufHysteresisTime: 0,
                    responseTime: 5000,
                },
                voltage: {
                    flag: 1,
                    x1: 254.4,
                    y1: 100,
                    x2: 254.4,
                    y2: 100,
                    x3: 254.4,
                    y3: 100,
                    x4: 264,
                    y4: 0,
                    responseTime: 5000,
                },
            },
            reactivePower: {
                autoVrefAvgTime: 300,
                cospiSetPoint: {
                    flag: 0,
                    excitedSelect: 1,
                    apparentPowerPriority: 1,
                    value: 1,
                    responseTime: 10000,
                },
                cospiP: {
                    flag: 0,
                    excitedSelect: 0,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                    x3: 0,
                    y3: 0,
                    responseTime: 0,
                },
                qSetPoint: {
                    flag: 0,
                    excitedSelect: 1,
                    apparentPowerPriority: 1,
                    reactivePowerMode: 3,
                    value: 44,
                    responseTime: 10000,
                },
                qU: {
                    flag: 1,
                    fixedVrefSelect: 0,
                    apparentPowerPriority: 1,
                    reactivePowerMode: 3,
                    vref: 240,
                    x1: 220.8,
                    y1: 30,
                    x2: 232.8,
                    y2: 0,
                    x3: 247.2,
                    y3: 0,
                    x4: 256.8,
                    y4: -30,
                    responseTime: 5000,
                },
                qP: {
                    flag: 0,
                    apparentPowerPriority: 1,
                    reactivePowerMode: 3,
                    responseTime: 10000,
                    gen: {
                        x1: 20,
                        y1: 0,
                        x2: 50,
                        y2: 0,
                        x3: 100,
                        y3: -44,
                    },
                    load: {
                        x1: 20,
                        y1: 0,
                        x2: 50,
                        y2: 0,
                        x3: 100,
                        y3: 44,
                    },
                },
            },
            dcInjection: {
                flag: 1,
                controlFlag: 1,
                controlLevel: 1,
                detectionLevel1: 0.32,
                detectionTime1: 1000,
                detectionLevel2: 0.46,
                detectionTime2: 500,
            },
            rcmu: {
                sudden: {
                    flag: 1,
                    detectionLevel1: 30,
                    detectionTime1: 150,
                    detectionLevel2: 60,
                    detectionTime2: 150,
                    detectionLevel3: 150,
                    detectionTime3: 40,
                },
                continuous: {
                    flag: 1,
                    detectionLevel: 250,
                    detectionTime: 300,
                },
            },
            pvInsulation: {
                flag: 0,
                faultLevel: 0,
                checkCnt: 0,
                time: 0,
            },
            antiIslanding: {
                activeMethodDetection: 1,
                passiveMethodDetection: 0,
                freqFeedbackFunction: 1,
                stepInjectionFunction: 0,
                reactivePowerSuppression: 0,
                gain1: 100,
                gain2: 100,
                freqFeedbackQmax: 0.25,
                stepInjectionQmax: 0.1,
            },
            gradient: {
                flag: 1,
                energySourceChange: 0,
                unitReferenceSelect: 0,
                activePowerGradient: 2,
                activePowerSetPointGradient: 100,
            },
            derating: {
                flag: 1,
                startTemp: 74,
                value: 5,
            },
            feedinRelay: {
                flag: 0,
                attachLevel: {
                    relay1: 0,
                    relay2: 0,
                    relay3: 0,
                    relay4: 0,
                },
                detachLevel: {
                    relay1: 0,
                    relay2: 0,
                    relay3: 0,
                    relay4: 0,
                },
            },
            inverterControl: {
                gridTargetVoltage: 240,
                gridTargetVoltageOffset: 0,
                pcsMaxApparentPowerLimit: 15356,
                chargeRateSetting: 7600,
                dischargeRateSetting: 7600,
                vaSetting: 7600,
                exportPmin: 5,
                importPmin: -100,
                pcsVarMax: {
                    q1: 9213,
                    q2: 4560,
                    q3: -4560,
                    q4: -4560,
                },
                pfMin: {
                    q1: 0.8,
                    q2: -0.8,
                    q3: 0.8,
                    q4: -0.8,
                },
                activePower: {
                    setting: 15356,
                    overExcitedSetting: 12284,
                    underExcitedSetting: 12284,
                },
                vArAct: 0,
            },
            dynamicReactiveCurrent: {
                flag: 0,
                arGraMod: 1,
                arGraSag: 1,
                arGraSwell: 1,
                dbVMin: -5,
                dbVMax: 5,
                holdTmms: 1000,
                filterTms: 5,
            },
            frt: {
                hvrt: 1,
                lvrt: 1,
                hfrt: 1,
                lfrt: 1,
                startLevel: {
                    hvrt: 264,
                    lvrt: 211.2,
                    hfrt: 61.2,
                    lfrt: 58.5,
                },
            },
            voltageRiseSuppression: {
                flag: 0,
                vref: 0,
                delayTime: 0,
                minPf: 0,
                pfResponseTime: 0,
                minActivePower: 0,
                activePowerResponseTime: 0,
                releaseTime: 0,
            },
            limitControl: {
                exportHardLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                exportSoftLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                generationHardLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                generationSoftLimit: {
                    flag: 0,
                    level: 0,
                    time: 0,
                },
                ess: {
                    exportLimit: 30400,
                    importLimit: -30400,
                },
            },
            cls: {
                exportLimit: 5000,
                importLimit: 18400,
            },
        },
    ],
};
